<template>
  <div class="dev-activity">
    <div class="da-label">{{ t('activity.title') }}</div>
    <ul class="da-list">
      <li v-for="d in devs" :key="d.user_id" class="da-row" :class="{ active: d.active }">
        <span class="da-av" :class="{ on: d.active }">{{ initials(d.name) }}</span>
        <div class="da-info">
          <div class="da-name">{{ d.name }}</div>
          <div class="da-task">
            <template v-if="d.active">
              <span class="da-dot"></span>{{ d.task_title }}
            </template>
            <template v-else>{{ t('activity.idle') }}</template>
          </div>
        </div>
        <span v-if="d.active" class="da-time num">{{ elapsed(d) }}</span>
      </li>
      <li v-if="devs.length === 0" class="da-empty">{{ t('activity.none') }}</li>
    </ul>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import api from '@/api'
import { useI18n } from '@/composables/useI18n'
import { onRealtime, debounce } from '@/composables/useRealtime'

export default {
  name: 'DevActivity',
  setup() {
    const { t } = useI18n()
    const devs = ref([])
    const now = ref(Date.now())
    let tick = null, off = () => {}

    const initials = (n) => (n || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    function elapsed(d) {
      let s = (d.timer_seconds || 0) + Math.max(0, Math.floor((now.value - new Date(d.timer_started_at.replace(' ', 'T')).getTime()) / 1000))
      const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60)
      return h ? `${h}:${String(m).padStart(2, '0')}` : `${m}m`
    }
    async function load() {
      try { devs.value = (await api.getActivity()).data || [] } catch {}
    }
    onMounted(() => {
      load()
      tick = setInterval(() => { now.value = Date.now() }, 1000)
      off = onRealtime('task.changed', debounce(load, 500))
    })
    onUnmounted(() => { clearInterval(tick); off() })

    return { t, devs, initials, elapsed }
  },
}
</script>

<style scoped>
.dev-activity { padding: 12px 4px 6px; border-top: 1px solid var(--sb-divider); margin-top: 8px; }
.da-label { font-size: 10px; font-weight: 700; letter-spacing: .8px; text-transform: uppercase; color: var(--sb-ink-2); padding: 0 9px 8px; }
.da-list { list-style: none; display: flex; flex-direction: column; gap: 2px; }
.da-row { display: flex; align-items: center; gap: 10px; padding: 7px 9px; border-radius: 10px; }
.da-row.active { background: var(--sb-hover); }
.da-av { width: 28px; height: 28px; border-radius: 8px; flex: none; display: grid; place-items: center; font-size: 11px; font-weight: 700; background: rgba(255,255,255,.08); color: var(--sb-ink); }
.da-av.on { background: var(--sb-active); color: #fff; }
.da-info { flex: 1; min-width: 0; }
.da-name { font-size: 12.5px; font-weight: 600; color: var(--sb-ink); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.da-task { font-size: 11px; color: var(--sb-ink-2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: flex; align-items: center; gap: 5px; }
.da-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--sb-icon); flex: none; animation: da-pulse 1.4s ease-in-out infinite; }
@keyframes da-pulse { 0%,100% { opacity: 1; } 50% { opacity: .3; } }
.da-time { font-size: 11px; color: var(--sb-icon); flex: none; }
.da-empty { font-size: 11px; color: var(--sb-ink-2); padding: 4px 9px; }
</style>
